export const config = {
  BASE_URL: "https://dev-hop.fr",
};
